export default "__VITE_ASSET__jg8LUBqT__"